import { render, staticRenderFns } from "./ArnicaResolver.vue?vue&type=template&id=88adbce6&scoped=true"
import script from "./ArnicaResolver.vue?vue&type=script&lang=ts"
export * from "./ArnicaResolver.vue?vue&type=script&lang=ts"
import style0 from "./ArnicaResolver.vue?vue&type=style&index=0&id=88adbce6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88adbce6",
  null
  
)

export default component.exports